import { Nav, Navbar } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { logout } from "../../redux/actions/userActions";
import { useDispatch } from "react-redux";
import FetchAuthFromServer from "../FetchAuthFromServer";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const AdminSalesLinksComponent = () => {
  const dispatch = useDispatch();
  const isAuth = FetchAuthFromServer();
  const location = useLocation();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (Object.keys(isAuth).length > 0) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [isAuth]);

  const [openMarketing, setOpenMarketing] = useState(false);
  const [openDevelopers, setOpenDevelopers] = useState(false);
  const [openClientVersion, setOpenClientVersion] = useState(false);

  const adminSalesLinks = [
    {
      title: "Home",
      link: "/admin/sales",
      access: "isSuperAdmin, isExtSales",
    },
    {
      title: "Orders & Users",
      link: "/admin/salesOrders",
      access: "isSuperAdmin, isExtSales",
    },
    // {
    //   title: "Representatives",
    //   link: "/admin/salesReps",
    //   access: "isSuperAdmin, isExtSales",
    // },
    // {
    //   title: "Customers",
    //   link: "/admin/salesUsers",
    //   access: "isSuperAdmin, isExtSales",
    // },
    // {
    //   title: "Companies",
    //   link: "/admin/deliveryBooks",
    //   access: "isSuperAdmin, isExtSales",
    // },
  ];

  const hasAccess = (access) => {
    if (access === "all") return true;
    const roles = access.split(",");
    return roles.some((role) => isAuth[role.trim()]);
  };

  const isPathInLinks = (links) =>
    links.some((link) => location.pathname === link.link);


  const isPathActive = (path) => {
    return location.pathname.includes(path);
  };

  if (loading) {
    return (
      <Navbar className="user_side_navBar" style={{ backgroundColor: "white" }}>
        <Nav className="flex-column user_side_nav">
          <img src="/loading-gif.gif" alt="Loading" style={{ width: "150px", marginTop: "25%" }} className="loading-spinner" />
        </Nav>
      </Navbar>
    );
  }

  return (
    <>
      <Navbar className="user_side_navBar">
        <Nav className="flex-column user_side_nav">
          {/* <Nav.Link style={{ color: "black" }} disabled>
            Sales Portal :
          </Nav.Link> */}

          {adminSalesLinks.map((link) => {
            if (hasAccess(link.access)) {
              if (link.title === "Quotes") {
                return (
                  <LinkContainer key={link.title} to={link.link} isActive={() => isPathActive('/admin/quotes')}>
                    <Nav.Link className="user_side_nav_options">
                      {link.title}
                    </Nav.Link>
                  </LinkContainer>
                );
              } else {
                return (
                  <LinkContainer key={link.title} to={link.link}>
                    <Nav.Link className="user_side_nav_options">
                      {link.title}
                    </Nav.Link>
                  </LinkContainer>
                );
              }
            }
            return null;
          })}
        </Nav>
      </Navbar>
      <br />
    </>
  );
};

export default AdminSalesLinksComponent;
